export default __webpack_public_path__ + "static/media/effect-8.bb9303f8.mp3";